<div class="modal-header com-modal-header" style="padding: 0px 15px 0px 5px;">
    <div class="row com-modal-row">
      <div class="mr-auto h4 com-modal-m">
          <h4 class="com-modal-tittle">DOWNLOAD FILES</h4>
      </div>
        <div class="com-modal-tittle-div"> 
          <i class="mdi mdi-close com-modal-icon" (click)="dismiss()"></i>
        </div>
    </div>
  </div>
  <div class="modal-body download-modal-body">
    <div  *ngFor="let  invAttach of invoiceAttachmentWebForm" >
        <a>
            <span (click)="downloadAttachment(invAttach)" class="download-modal-att"> {{invAttach?.RawFileName}} </span>  
        </a>
  </div>
</div> 
<div style="text-align: end;padding: 20px;" >
  <button type="button" class="freight-primary"  (click)="dismiss()" style="padding-left: 40px !important;padding-right: 40px!important;">Download All</button>
</div>
